import auth from "../../../../../../../../chunks/auth.js";
import { error, json } from "@sveltejs/kit";
import { p as prisma } from "../../../../../../../../chunks/prisma.js";
const PUT = async ({ locals, params, request }) => {
  if (!await auth.isAdmin(locals.user)) return error(401, "Unauthorized");
  const orderId = Number(params.orderid);
  const productId = Number(params.productid);
  const { isIssued } = await request.json();
  try {
    await prisma.productOnOrder.update({
      where: { orderId_productId: { orderId, productId } },
      data: { isIssued: !!isIssued }
    });
    return json({ success: true });
  } catch (e) {
    console.log("issueProduct Err:", e);
    return error(500, "Internal server error issuing product");
  }
};
export {
  PUT
};
